import React, { useState } from "react";
import PostList from "src/Components/Custom/PostList/PostList";
import EndPoints from "src/Constants/EndPoints";
import { useTranslation } from "react-i18next";

function MyPosts() {
  const [postData, setPostData] = useState<any>([]);
  const { t, i18n } = useTranslation();

  return (
    <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-9">
            <div className="col_selector">
              <PostList
                endPoint={EndPoints.myPosts}
                placeholderMessage={"Posts not found"}
                postData={postData}
                setPostData={setPostData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyPosts;
